import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d1bdd9f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1bdd9f')) {
      api.createRecord('2d1bdd9f', component.options)
    } else {
      api.reload('2d1bdd9f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2d1bdd9f", function () {
      api.rerender('2d1bdd9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataAccess/questionnaire/index.vue"
export default component.exports